module.exports = __webpack_public_path__ + "img/53852996ef4f6d46552b008ad4746a5e.bae3108a.png";